import rules from "../../Data/Rules"
import functions from "../../Data/Functions"
import Verification from "../Steps/Verification"
import Base_Details from "../Steps/BaseDetails"

let Model = {};

export default {
    init: async (Parameters) => {
        Parameters.AboriginalStatus = await functions.GetCodeBy({ Type: "Aboriginal Status" })
        Parameters.step1 = await Verification.LoadSchema(1)
        Parameters.step2 = await Base_Details.LoadSchema(2)
        Parameters.step1.Model = Model
        Parameters.step2.Model = Model
        return LoadModel(Parameters)
    },
    valid: (ev, ele, Params) => {
        // console.log(Model)
        // console.log(ev, ele, Params);
        let data = ev.data
        let key = ev.key
        if (ele) {
            switch (Params.Type) {
                case 'Player':
                    switch (key) {
                        case 'surname':
                            // surname = ev.value
                            break;
                        default:
                            break;
                    }
                    break;
                default:
                    break;
            }
        }
    },
    save: async (results) => {
        // let Contacts = {}
        let ContactDetails = []
        let files = []
        results.steps.forEach((step) => {
            // console.log(step.Model)
            let id = 0, Doc_id = 0, value = ''
            for (const property in step.Model) {
                // Reset the variables
                id = 0, Doc_id = 0, value = ''
                for (const item in step.Schema[property]) {
                    // console.log(item)
                    // if (item == 'id') { id = Number(step.Schema[property][item]) }
                    // if (item == 'Docid') { Doc_id = Number(step.Schema[property][item]) }
                    // if (item == 'type' && step.Schema[property][item] == 'file') { file = true }

                    // console.log(item, step.Schema[property][item])
                    switch (item) {
                        case 'id':
                            id = Number(step.Schema[property][item])
                            break;
                        case 'Doc_id':
                            Doc_id = Number(step.Schema[property][item])
                            break
                        case 'Doc_Label':
                            Doc_Label = step.Schema[property][item]
                            break
                        case 'teams':
                            Teamlist = step.Model[property]
                            break
                        default:

                            break;
                    }
                }
                // field = property
                value = step.Model[property]
                // console.log(`${property}: ${step.Model[property]}`);
                if (id > 0) {
                    // console.log(id, field, value);
                    ContactDetails.push({ Type: id, Description: value })
                }
                if (Doc_id > 0) {
                    files.push({ Type: Doc_id, File: value })
                }
            }
        })

        let payload = {
            Portal_Data: results,
            Contact: {
                firstname: results.steps[0].Model.firstname,
                surname: results.steps[0].Model.surname,
                email: results.steps[0].Model.email,
                mobile: results.steps[0].Model.mobile,
                gender: functions.getDBGender(results.steps[0].Model.gender),
                date_of_birth: results.steps[0].Model.DOB,
                password: results.steps[0].Model.password,
                photo: functions.formDataFile(results.steps[0].Model.photo),
                team: 310,
                role: 3
            },
            Contact_Details: ContactDetails,
            Files: files
        }
        // functions.LoadData(payload);
        console.log(payload)
        console.log(results)
    }
}

const LoadModel = (Passed) => {
    let result = {}
    switch (Passed.Type) {
        // Player Form
        case 'Player':
            result = {
                Portal: '2022 BSA Player',
                MainColor: "oug",
                Logo: require('../../assets/BSA.png'),
                Title: `<h2>Basketball South Australia Registration Form</h2>`,
                Description: ``,
                steps: [
                    // Step 1
                    Passed.step1,
                    Passed.step2,
                    {
                        stepno: 3,
                        title: 'Other Details',
                        valid: true,
                        information: '',
                        Model: {},
                        Schema: Passed.step3Schema,
                    },
                    {
                        stepno: 4,
                        title: 'Product Selection',
                        valid: true,
                        information: ``,
                        Model: {},
                        Schema: {
                            Product: {
                                type: 'select',
                                label: 'Select the product you wish to purchase',
                                outlined: true,
                                dense: true,
                                rules: [rules.requiredMsg('Product is Required')],
                                class: 'mx-1 px-1',
                                items: [
                                    "Product 1 - $23.54",
                                    "Product 2 - $54.24",
                                    "Product 3 - $12.05",
                                ]
                            },
                        },
                    },
                    {
                        stepno: 5,
                        title: 'Payment',
                        valid: true,
                        information: '',
                        Model: {},
                        Schema: {
                            Name: {
                                type: 'text',
                                label: `Name on Credit Card`,
                                outlined: true,
                                dense: true,
                                prependInnerIcon: 'person',
                                rules: [rules.requiredMsg('Name on Credit Card is Required')],
                                class: 'mx-1 px-1',
                                col: 12,
                            },
                            CardNo: {
                                type: 'number',
                                label: `Credit Card Number`,
                                outlined: true,
                                dense: true,
                                prependInnerIcon: 'card',
                                rules: [rules.requiredMsg('Credit Card Number is Required')],
                                class: 'mx-1 px-1',
                                col: 12,
                            },

                        },
                    },
                    {
                        stepno: 6,
                        title: 'Confirmation',
                        valid: true,
                        information: `Thank you for your submitted registration 
                            Please stay up to date with all NBL1 news and information throughout the season on the <a href="https://nbl1.com.au/" target="blank">NBL1 website</a><br></br>`,
                        Model: {},
                        Schema: {}
                    }

                ]
            }
            break;

        default:

            break;
    }
    return result;
}

